type Listener = (status: string) => void;

const listeners = new Map<string, Set<Listener>>();

/**
 * Raw `live-stream-status` pushes for one event, payload status included.
 * The provider only invalidates `liveStreams.get`, which can't express
 * transient states that never reach the DB (TRA-2805's "CONNECTING").
 */
export function subscribeLiveStreamStatus(
  eventId: string,
  fn: Listener,
): () => void {
  let set = listeners.get(eventId);
  if (!set) {
    set = new Set();
    listeners.set(eventId, set);
  }
  set.add(fn);

  return () => {
    const current = listeners.get(eventId);
    if (!current) return;
    current.delete(fn);
    if (current.size === 0) listeners.delete(eventId);
  };
}

export function emitLiveStreamStatus(eventId: string, status: string): void {
  const set = listeners.get(eventId);
  if (!set) return;
  set.forEach((fn) => fn(status));
}
